import http from "~/common/http";

export const  RoleModel = {
    id: 0,
    name: "",
    allow_range: 0,
    allow_branches: [],
    max_customer_limit: 0,
    max_vip_limit: 0,
    memo: ""
};

export const ALLOW_SELF = 1; // 只允许查看自己数据(公共客户除外)
export const ALLOW_CURRENT_BRANCH = 2; // 只允许查看本部门数据
export const ALLOW_BRANCHES = 3; // 允许查看指定部门数据
export const ALLOW_ALL = 4; // 允许查看所有数据
export const ALLOW_NOT_ALL = 5; // 所有数据都不允许查看
export const ALLOW_CURRENT_BRANCH_AND_CHILDREN = 6; // 允许查看本部门及下级部门数据

export const RoleService = {

    /**
     * 创建角色
     * @param role
     * @returns {*}
     */
    create(role) {
        return http.post('/api/rbac/roles/create', role);
    },

    /**
     * 编辑角色信息
     * @param role
     * @returns {IDBRequest | Promise<void>}
     */
    update(role) {
        return http.put('/api/rbac/roles/update?id=' + role.id, role);
    },

    /**
     * 删除角色信息
     * @param roleId
     * @returns {*}
     */
    delete(roleId) {
        return http.delete('/api/rbac/roles/delete?id=' + roleId);
    },

    /**
     * 角色授权
     * @param params
     * @returns {*}
     */
    authorization(params) {
        return http.post('/api/rbac/roles/authorization', params);
    },

    /**
     * 得到角色信息
     * @param roleId
     * @returns {*}
     */
    getRoleInfo(roleId) {
        return http.get('/api/rbac/roles/view', {
            params: {id: roleId}
        })
    },

    /**
     * 得到角色列表
     * @param params
     * @returns {*}
     */
    getList(params) {
        return http.get('/api/rbac/roles/index', {params: params});
    },

    /**
     * 得到角色许可范围枚举序列
     * @returns {*}
     */
    getAllowRanges() {
        return http.get('/api/rbac/roles/allow-ranges');
    },

    /**
     * 得到所有许可范围枚举序列
     * @returns {{[p: string]: string, [p: number]: string}}
     */
    getAllowEnums() {
        return {
            [ALLOW_SELF]: '只允许查看自己数据(公共客户除外)',
            [ALLOW_CURRENT_BRANCH]: '只允许查看本部门数据',
            [ALLOW_CURRENT_BRANCH_AND_CHILDREN]: '允许查看本部门及下级部门数据',
            [ALLOW_BRANCHES]: '只允许查看指定部门数据',
            [ALLOW_ALL]: '允许查看所有数据',
            [ALLOW_NOT_ALL]: '所有数据都不允许查看'
        };
    },

    /**
     * 得到指定许可范围的备注文本
     * @param key
     * @returns {*}
     */
    getAllowMemo(key) {
        let allows = this.getAllowEnums();
        return allows[key] ? allows[key] : '';
    },

    /**
     * 得到许可范围Options 用于给Select组件使用
     * @returns {Array}
     */
    getAllowRangeOptions() {
        let allows = this.getAllowEnums();
        let options = [];
        for (var index in allows) {
            let value = index;
            let label = allows[index];
            options.push({
                label: label,
                value: parseInt(value)
            });
        }

        return JSON.parse(JSON.stringify(options));
    }

}



// WEBPACK FOOTER //
// ./src/services/Role.js